module.exports = __webpack_public_path__ + "img/01.4911afc6.png";